import { vigilkidsTheme } from './theme'
import { requireApiBaseURL, requireProductReturnOrigin } from '../env'

import type { BrandConfig } from '@checkout/themes'

const logoLight = '/assets/vigilkids/logo-light.png'
const logoDark = '/assets/vigilkids/logo-light.png'
const favicon = '/assets/vigilkids/favicon.ico'
const apiBaseURL = requireApiBaseURL('vigilkids')
const productReturnOrigin = requireProductReturnOrigin('vigilkids')

/** Airwallex 环境，从环境变量读取，默认 prod */
const airwallexEnv = (import.meta.env.VITE_AIRWALLEX_ENV as 'prod' | 'demo') || 'prod'

export const vigilkidsConfig: BrandConfig = {
  id: 'vigilkids',
  name: 'VigilKids',

  theme: vigilkidsTheme,

  logo: {
    light: logoLight,
    dark: logoDark,
    width: 134,
    height: 40,
  },

  header: {
    languageSwitcherSize: 'md',
    securityBadges: [
      { src: '/assets/badges/pci-dss.png', alt: 'PCI DSS', width: 78 },
      { src: '/assets/badges/ssl-secure.png', alt: 'SSL Secure', width: 74 },
      { src: '/assets/badges/verified.png', alt: 'Verified', width: 62 },
    ],
  },

  favicon,

  api: {
    baseURL: apiBaseURL,
    productCode: 'vigilkids',
    timeout: 30000,
  },

  // 支付方式由后端 API 统一返回，前端不需要配置

  features: {
    expressCheckout: true,
    couponCode: false,
    guestCheckout: true,
    showProductImages: true,
    darkModeToggle: false,
    showCurrencySelector: true,
  },

  locale: {
    defaultCurrency: 'USD',
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'es', 'pt', 'de', 'fr'],
  },

  legal: {
    termsUrl: 'https://www.vigilkids.com/terms-of-use/',
    privacyUrl: 'https://www.vigilkids.com/privacy-policy/',
    refundPolicyUrl: 'https://www.vigilkids.com/refund-policy/',
    subscriptionTermsUrl: 'https://www.vigilkids.com/terms-of-use/',
  },

  // Footer and terms text use i18n keys - translations in locales/*.json
  // If not configured, uses default translations from i18n
  footer: {},
  termsText: {},

  contact: {
    email: 'support@vigilkids.com',
    supportUrl: 'https://help.vigilkids.com',
  },

  appLinks: {
    ios: 'https://apps.apple.com/us/app/parental-control-app-vigilkids/id6752842823',
    android: 'https://play.google.com/store/apps/details?id=com.vigilkids.assistant.parent',
  },

  embeddedPayments: {
    airwallex: {
      env: airwallexEnv,
      applePay: {
        buttonType: 'buy',
        buttonColor: 'black',
      },
      googlePay: {
        buttonType: 'buy',
        buttonColor: 'black',
      },
    },
  },

  productReturnOrigin,

  // GA/GTM 埋点配置
  analytics: {
    enabled:
      import.meta.env.VITE_ANALYTICS_ENABLED === 'true' ||
      (typeof window !== 'undefined' && window.location.hostname === 'checkout.vigilkids.com'),
    // GTM 容器 ID
    gtmId: 'GTM-59C4CRWK',
    // 模块名称前缀，用于区分不同品牌的事件
    modulePrefix: 'vk_checkout_',
  },
}
